module.exports = [{"type":"title","text":"2023-12-08"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"現貨:24小時價格變動新增價格百分之字段"},{"type":"html","text":"現貨:查詢委託訂單列表支持symbol非必填，不填寫symbol字段會返回用戶所有幣對的當前委託單"},{"type":"html","text":"永續一鍵平倉接口: 新增”symbol“非必填string字段,不填市價平倉所有幣對持倉,填寫後市價平掉對應幣對倉位"},{"type":"html","text":"永續撤銷全部訂單接口: 1,入參”symbol“改為非必填,不填時撤銷所有訂單,填入時撤銷對應幣對的訂單 2,入參新增”type“非必填字段,填寫時撤銷指定類型的訂單,不填撤銷所有訂單類型的訂單"},{"type":"html","text":"子賬戶:查詢子賬戶列表:調整入參字段limit:最大1000"},{"type":"html","text":"子賬戶:創建子賬戶apikey:入參字段permissions，新增參數值：5-提幣"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2023-12-08.json
// module id = +29D
// module chunks = 3